import { State } from '../../reducers/rootReducer'
import { ModelId } from '../../../entities/Model'

const configuredModelIdSelector = (state: State): ModelId => state.configurationData.modelId

export default configuredModelIdSelector
